export const AddressingResultActionTypes = {
  FETCH_AddressResults_REQUEST: "FETCH_AddressResults_REQUEST",
  FETCH_AddressResults_SUCCESS: "FETCH_AddressResults_SUCCESS",
  FETCH_AddressResults_FAILURE: "FETCH_AddressResults_FAILURE",
  CLEAR_AddressResults: "CLEAR_AddressResults",
  FETCH_DATA_FROM_COOKIES: "FETCH_DATA_FROM_COOKIES",
};
